import React, { Component } from 'react';
import { Row , Col , Form , Table ,Input , Button, message , Tag, Card, Spin, Alert, Modal, InputNumber , Switch, Drawer, Tabs , Select}from 'antd'
import axios from 'axios';
import keys from '../../../keys';
import CardToPrint from '../../v2/components/CardToPrint';
import getData from '../../v2/utilities/getdata'
import Description from '../../v2/components/Description';
import Search from '../../v2/components/Search';

const {Option} = Select

const CloseAccountForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onOk, form , loading} = this.props;
        const { getFieldDecorator } = form;
        return (
          <Modal
            visible={visible}
            title={`Cancel Instalment plan (${this.props.invoice_no})`}
            okText="Close Account"
            onCancel={onCancel}
            onOk={onOk}
          >
            <Spin spinning={loading}>
            <Form layout="vertical">
              <Form.Item label="Username">
                {getFieldDecorator('username', {
                  rules: [{ required: true, message: 'Username is required!' }],
                })(<Input />)}
              </Form.Item>
              <Form.Item label="Password">
                {getFieldDecorator('password', {
                  rules: [{ required: true, message: 'Password is required!' }],
                })(<Input type="password" />)}
              </Form.Item>
              <Form.Item label="Balance Amount">
                {getFieldDecorator('balance',{
                 rules: [{ required: true, message: 'You should verify the balance amount!' }]
                })(<InputNumber style={{width:"200px"}} min={0} />)}
              </Form.Item>
              <Form.Item label="Block Customer" style={{marginBottom:0}}>
                {getFieldDecorator('block_customer', {
                  valuePropName: 'checked' 
                })(
                    <Switch  />,
                )}
              </Form.Item>
            </Form>
            </Spin>
          </Modal>
        );
      }
    },
  );



class OrderDetails extends Component {
    state = {
        loading : false,
        saleDetails : {},
        invoice_no: this.props.invoice_no,
        disablePayments : this.props.invoice_no ? false : true,
        routes : [],
        data : [],
        overDue : this.props.overDue || 0.00,
        totalDue : 0.00,
        amountPaid : 0.00,
        balance : 0.00,
        visibleCloseAccountModal : false,
        modalLoading:false
    }

    componentDidMount(){
      
        if(this.props.invoice_no){
            this.fetchData()
        }
        if(this.props.fetchOrder){
            this.props.fetchOrder(this.props.order_id,
                (invoice_no) => {this.setState({invoice_no:invoice_no},this.fetchData)
                }
                )
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.invoice_no !== prevProps.invoice_no){
            this.setState({invoice_no:this.props.invoice_no},this.fetchData)         
        }
    }

    

    fetchData = () =>{

        this.setState({loading:true})
        
        axios.all(
            [
                axios.get(`${keys.server}/instalments/dues/${this.state.invoice_no}`),
                axios.get(`${keys.server}/instalments/overdues/${this.state.invoice_no}`),
                axios.get(`${keys.server}/sales/orderreciepts/${this.state.invoice_no}`),
                axios.get(`${keys.server}/sales/orders/${this.state.invoice_no}/`),
                axios.get(`${keys.server}/warehouse/routes/`)

            ]
        )
        .then(
            axios.spread((dues , overdues , reciepts,order, routes)=>{

                const total_due = dues.data.reduce((sum,value) => sum + parseFloat(value.due_amount) , 0)
                const amountPaid =  dues.data.reduce((sum,value) => sum + parseFloat(value.amount_paid || 0.00) , 0)
                const balance = total_due - amountPaid
                const overdue = overdues.data.reduce((sum , value) => sum + parseFloat(value.amount_payable) , 0)
                const initialPayment = reciepts.data.filter(reciept => reciept.payment_type === "INITIAL").pop().payment
                const disablePayments = balance === 0 ? true : false
               
                this.setState({
                    routes : routes.data,
                    order_id: order.data.id,
                    order_date : order.data.date,
                    instalment_plan_id : order.data.instalment_plan_id,
                    data : dues.data,
                    totalDue : total_due,
                    amountPaid : amountPaid,
                    balance : balance,
                    initialPayment : initialPayment,
                    overDue : overdue ,
                    disablePayments: disablePayments,
                    loading :false       
                })
                this.props.updateInvoice && this.props.updateInvoice(this.state.invoice_no)
                this.props.updateOverDue && this.props.updateOverDue(this.state.overDue,balance)
        }
    ))
    .catch(
        err => {       
            // alert(err.message)
            switch(err.response.status){
                case 404:{
                    message.error(err.response.data)      
                    this.setState({
                        loading : false,
                        invoice_no: this.props.invoice_no,
                        data : [],
                        overDue : this.props.overDue || 0.00,
                        totalDue : 0.00,
                        amountPaid : 0.00,
                        balance : 0.00,
                        visibleCloseAccountModal : false,
                        modalLoading:false
                    })
                    break
                }
                default:{
                    message.error("Invalid invoice number!")   
                }
            }
              
            this.setState({
                loading : false
            })
        }
    )

    }


    handleSubmit = (e)=>{
        e.preventDefault()
        this.fetchData()       
    }

    /// funtions releated to close account form
    handleCloseAccount = () => {
        const { form } = this.formRef.props;
       
        form.validateFields((err, values) => {
           
          if (err) {
            return;
          }    

          console.log(values)

        this.setState({
            modalLoading : true
        })
          axios.post(`${keys.server}/user/get-auth-token/`,{
              username:values.username,
              password:values.password,
              emp_type:"MANAGER"
          })
          .then(
              (response) => {

                return axios.post(
                    `${keys.server}/instalments/plan/cancel`,{    
                        "invoice": this.state.invoice_no ,
                        "balance_amount": values.balance,
                        "block_customer": values.block_customer & true
                    },
                    {
                        headers:{
                            Authorization: `Token ${response.data.token}`
                        }
                    }
                )
              }
          )
          .then(
                response => {
                    message.success("Successfully closed the account")
                    form.resetFields();
                    this.setState({ visibleCloseAccountModal: false , modalLoading:false , invoice_no:null },() => this.props.updateInvoice(this.state.invoice_no));     
                }
          )
          .catch(
              error => {   
                console.error(error)
                if(error.response){
                    switch(error.response.status){
                        case 401: {
                            message.error("Account doesn't have permission to cancel instalment plan")
                            break
                        }
                        case 400: {      
                            message.error(JSON.stringify(error.response.data))
                            break
                        }
                        default :{
                            message.error("Oops! Something when wrong. Try once more and contact support!")
                        }
                    }
                  
                }
               
                this.setState({
                    modalLoading : false
                })
              }
          )
         
         
          
        });
      };
    
      saveFormRef = formRef => {
        this.formRef = formRef;
      };

      handleEditOkay = () => {
          const data = {
              route : this.state.route_id,
              week_day : this.state.weekday
          }
          
          return axios.patch(`/api/instalments/instalmentplan/${this.state.instalment_plan_id}`, data)
          .then(
              response => {
                  message.success("Instalment plan updated!")
                  this.setState({
                      showEditModal:false
                  },()=>{
                      this.handleClickShowMore()
                  })
              }
          ).catch(
              err => {
                  message.error("Operation failed")
                  console.error(err)
              }
          )
      }


      printCard = ()=>{
            const url = `api/instalments/cards/${this.state.instalment_plan_id}/`
            this.setState({loading : true})
            getData(url,{},()=>message.success("Card is ready!"),()=>message.error("OOPS!, Can not print card!"))
            .then(
                data => {
                    const cardData = {
                        invoiceNo : data.invoice_no,
                        issueDate : this.state.order_date.substr(0,10), //this date is changed to sale data not plan starting date
                        endDate : data.end_date,
                        salesPersonID : data.sales_person_code,
                        vehicleNo : data.vehicle_no,
                        customerName : data.customer_name,
                        customerID : data.customer_id,
                        customerAddress : data.customer_address,
                        customerNIC : data.customer_nic,
                        contactNo : data.customer_contact_no,
                        initialPayment : data.initial_payment,
                        numberOfTerms : data.no_of_terms,
                        totalBill : data.total_bill,
                        weekday : data.week_day,
                        type : data.installment_type,
                        route : data.route,
                        items : data.items.toString()
                    }
                    this.setState({
                        showCardToPrint : true,
                        cardData : cardData
                    })  
                }
            )
            .catch(
                err => console.error(err)
            )
            
      }

      onPrintClose = () => {
          this.setState({
              showCardToPrint : false,
              cardData : null,
              loading : false
          })
      }
    
    
    completePayment = () => {
        Modal.confirm(
            {
                title : "Are you sure?",
                message : "Do you want to complete this account?",
                onOk : () => {
                    return axios.patch(`${keys.server}/instalments/instalmentplan/${this.state.instalment_plan_id}`,{status : "COMPLETE"})
                            .then(response => {
                                message.success("This order marked completed")
                            })
                            .catch(
                               err => {
                                message.error("Oops! something went wrong. Try again")
                                console.error(err)
                               }
                            )
                }
            }
        )
    }

     

    createPayment = () => {  
            this.props.nextStep()  
    }

    handleClickShowMore = () => {
        this.setState({
            loading : true
        },
        ()=>{

                axios.all([
                    axios.get(`${keys.server}/sales/orders/${this.state.order_id}/saledetails/`),
                    axios.get(`${keys.server}/sales/orders/${this.state.order_id}/orderlines/`),
                    axios.get(`${keys.server}/sales/orders/${this.state.order_id}/salesperson/`)
                ])
                .then(axios.spread((orderDetails,orderLines,salesPerson)=>{
                    const saleDetails = {
                        "Sale Details" : orderDetails.data,
                        "Order Details" : orderLines.data,
                        "Vehicle and Sales Person" : salesPerson.data
                    }
                    this.setState({
                        saleDetails : saleDetails,
                        loading: false,
                        showMore:true
                    })
                }))
                .catch(err =>{
                    message.error("Loading more details failed!")
                    this.setState({
                        loading:false
                    })
                })

            }   
        )     
    }

    columns = [

        {
            key:1,
            dataIndex : "due_date",
            title : "Due Date",
            width:150
        }
        ,
        {
            key:2,
            dataIndex : "title",
            title : "Term",
            width:150
        }
        ,
        
        {
            key:3,
            dataIndex : "due_amount",
            title : "Due Amount",
            render : due_amount => "Rs. " + due_amount ,
            width:150
        }
        ,
        {
            key:4,
            dataIndex : "amount_paid",
            title : "Amount Paid",
            render : amount_paid => amount_paid ? "Rs. " + amount_paid : "Rs. " + 0 ,
            width:150
        }
        ,
        {
            key:5,
            dataIndex : "amount_payable",
            title : "Amount Payable",
            render : amount_payable => "Rs. " + amount_payable,
            width:150
        }
        ,
        {
            key:6,
            dataIndex : "is_paid",
            title : "Due Status",
            render : (is_paid) => is_paid ? <Tag color="#87d068">Paid</Tag> : <Tag color="#f50">Not Paid</Tag>
        }
    ]

    onTabChange = (activeKey) => {
        if( activeKey==="collections" && this.state.order_id ){
            this.setState({loadingCollections:true}
            ,()=>{
                axios.get(`/api/sales/orders/${this.state.order_id}/collections/`)
                .then(
                    response => {
                        this.setState({
                            collectionData: response.data,
                            loadingCollections:false
                        })
                    }
                )
                .catch(err => {
                    message.error("Fetching collections failed")
                    console.error(err)
                })
            }    
            )
        }
    }

    onEditButtonClicked = () => {
        this.setState({
            showEditModal : true
        })
    }
    

    render() { 
      
        return ( 
            <>
            <Spin spinning={this.state.loading}>
                <Row gutter={20}>
                    <Form onSubmit={this.handleSubmit}>
                    <Col span={16}>
                        {/* <Search onValueChange = {id => this.setState({order_id:id},()=>alert(JSON.stringify(this.state)))}/> */}
                        <Input required={true} readOnly={this.props.viewOnly} tabIndex={1} onChange={e => this.setState({invoice_no:e.target.value.toUpperCase()})} value={this.state.invoice_no} placeholder="Enter Invoice Number"></Input>
                    </Col>
                    <Col span={8}>
                        <Button tabIndex={2} block htmlType="submit" type="primary">Search Invoice</Button>
                    </Col>
                    </Form>
                </Row>
                <Row style={{marginTop:"20px"}} gutter={20}>
                    <Col span={16}>
                        <Row style={{paddingBottom:"10px"}} gutter={10}>   
                            <Col  span={8}>
                                <Card  size="small" title="Overdue">
                                    Rs. {this.state.overDue}
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card  size="small" title="Total Due">
                                Rs.    {this.state.totalDue}
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card size="small" title="Initial Payment">
                                Rs.  {this.state.initialPayment || 0}
                                </Card>
                            </Col>  
                        </Row>
                        <Row gutter={10}>
                            <Col span={8}>
                                <Card  size="small" title="Amount Paid">
                                Rs. {this.state.amountPaid}
                                </Card>
                            </Col>
                            <Col   span={8}>
                                <Card size="small" title="Balance">
                                Rs. {this.state.balance}
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Button 
                                    type="primary" 
                                    block
                                    disabled = {!this.state.order_id}
                                    onClick = {this.handleClickShowMore}
                                    >
                                        Show More
                                </Button>
                            </Col>            
                        </Row>
                  </Col>
                    <Col span={8}>
                       { 
                       this.props.viewOnly? 
                       <>
                        {this.props.extraComponent}
                        
                       </>:
                       <>
                            <Row style={{marginTop:"10px"}}>
                                <Col span={24}>
                                    <Button disabled={this.state.disablePayments} onClick={this.printCard}  type="primary" block> Print Card</Button>
                                </Col>
                            </Row> 
                            <Row style={{marginTop:"10px"}}>
                                <Col span={24}> <Button onClick={()=>this.setState({visibleCloseAccountModal:true})} disabled={this.state.disablePayments} block type="danger"> Close Account </Button></Col>
                            </Row>
                           
                            <Row style={{marginTop:"10px"}}>
                                <Col span={24}> <Button onClick={this.completePayment} disabled ={ (this.state.balance === 0 && this.state.order_id) ? false: true}  block type="primary">  Complete  </Button></Col>
                            </Row>   
                            <Row style={{marginTop:"20px"}}>
                                    <Col span={24}>
                                        <Button disabled={this.state.disablePayments} tabIndex={3} onClick={this.createPayment} size="large" type="primary" block> Create Payment</Button>
                                    </Col>
                            </Row>                        
                        </>
                        }    
                   </Col>
                </Row>
                <Row style={{marginTop:"20px"}}>
                    <Col span={24}>
                        <Tabs onChange={this.onTabChange} defaultActiveKey="installments">
                            <Tabs.TabPane  tab="Installments" key="installments">
                                <Table 
                                    rowKey={row => row.id}  
                                    scroll={{y:250}} pagination={false} 
                                    size="small"  
                                    columns={this.columns} 
                                    dataSource={this.state.data}>            
                                </Table>
                            </Tabs.TabPane>
                            <Tabs.TabPane  tab="Collections" key="collections">
                                <Table 
                                    rowKey={row => row.id} 
                                    loading ={this.state.loadingCollections}
                                    scroll={{y:250}} pagination={false} 
                                    size="small"  
                                    columns={CollectionColumns} 
                                    dataSource={this.state.collectionData}>            
                                </Table>
                            </Tabs.TabPane>
                        </Tabs>
                    </Col>
                </Row>
            </Spin>
           
            <CloseAccountForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.visibleCloseAccountModal}
                onCancel={()=>this.setState({visibleCloseAccountModal:false})}
                invoice_no = {this.state.invoice_no}
                onOk={this.handleCloseAccount}
                loading = {this.state.modalLoading}
                />
            {
                this.state.showCardToPrint && <CardToPrint onClose={this.onPrintClose} data={this.state.cardData}/>
            }
            
            <Drawer 
                visible={this.state.showMore}
                
                destroyOnClose
                onClose = {()=>this.setState({showMore:false})}
                title = "Order Details"
                width ="500px"
                
                >
                    {
                        Object.keys(this.state.saleDetails).map(key => <Row style={{padding:"5px 0px 20px" }}>
                            <Description col={2} title={key} data={this.state.saleDetails[key]}></Description>
                            </Row>)
                    }
                <Button onClick={this.onEditButtonClicked}> Edit Card </Button>
            </Drawer>
            <Modal 
                visible={this.state.showEditModal}
                onOk = {this.handleEditOkay}
                onCancel = {()=>this.setState({showEditModal:false})}
                title = "Edit Card"
                >
                <Form>
                    <Form.Item label="Weekday">
                       <Select onChange={(weekday)=>this.setState({weekday:weekday})}>
                            {                               
                        
                                ["MONDAY" , "TUESDAY" , "WEDNESDAY" , "THURSDAY" , "FRIDAY" , "SATURDAY" ,"SUNDAY" ].
                                map((day , index)=>{
                                            return <Option  key={index} value={day}>{day}</Option>
                                        }
                                    )
            
                            }
                       </Select>
                    </Form.Item>
                    <Form.Item label="Route">
                       <Select onChange={(v)=>this.setState({route_id:v})}>
                            {                                                  
                               this.state.routes.map((route , index)=>{
                                            return <Option  key={route.id} value={route.id}>{route.title}</Option>
                                        }
                                    )
            
                            }
                       </Select>
                    </Form.Item>
                </Form>

            </Modal>
            
            </>
            
         );
    }
}


const CollectionColumns = [
    {
        key : 1,
        title : "Type",
        dataIndex : "payment_type"
        
    },
    {
        key : 2,
        title : "Payment",
        dataIndex : "payment"

    },
    {
        key : 3,
        title : "Discount",
        dataIndex : "discount"

    },
    {
        key : 4,
        title : "Net Payment",
        dataIndex : "net_payment",
        render: (net_payment,row) => net_payment || (parseFloat(row.payment) - parseFloat(row.discount)).toFixed(2)
        
    },
    {
        key : 5,
        title : "Date",
        dataIndex : "date",
        render:(date) => date.substr(0,10)

    }
    ,
    {
        key : 6,
        title : "Sales Person",
        dataIndex : "sales_person_vehicle.sales_person"
       
    }
    

]
 
export default OrderDetails;